import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/hooks/useAnalytics';

// Component that tracks page views on route changes
export function RouteTracker() {
  const location = useLocation();

  useEffect(() => {
    // Track page view on route change
    trackPageView(location.pathname + location.search);
  }, [location]);

  return null;
}
